// Use the RXD API to get SCORM identity information
export const getScormIdentity = () => {
  const RXD = getRxdApi();
  return RXD?.GetStudentID() || RXD?.GetStudentName() || "";
};

/**
 * Sets the SCORM score and marks the lesson as passed.
 **/
export const setScormPassed = (scoring: ScormScoring) => {
  const RXD = getRxdApi();
  if (!RXD) return;

  // Set the score if it is provided
  if (scoring) {
    const { score, max, min } = scoring;
    RXD.SetScore(score, max, min);
  }

  RXD.SetPassed();
};

/**
 * Exit the SCORM lesson by conceding control back to the LMS
 **/
export const exitScormLesson = () => {
  const RXD = getRxdApi();
  if (!RXD) return;

  RXD.ConcedeControl();
};

// Use the RXD API to get access to the RXD object from the LMS
const getRxdApi = () => {
  let rxdPackage;
  try {
    rxdPackage = window.opener?.RXD || (window.parent as any)?.["RXD"];
  } catch (_error) {
    console.log("No LMS found");
  }
  return rxdPackage;
};

export type ScormScoring = {
  score: number;
  max: number;
  min: number;
};
